import { Injectable } from '@angular/core';
import { IRasterLayer } from '../../../interfaces/sjmap2/raster/IRaster';
import { BehaviorSubject, Subject } from 'rxjs';
import { TRasterLayerUUID } from '../../../types/explorer/sjmap2/TRaster';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsToolService {

  public readonly activeLayerUUIDTab$ = new BehaviorSubject<TRasterLayerUUID>("");
  public readonly openBottomBar$ = new Subject<void>();

  changeActiveLayerUUIDTab(layerUUID: TRasterLayerUUID) {
    this.activeLayerUUIDTab$.next(layerUUID);
  }

  triggerOpenBottomBar() {
    this.openBottomBar$.next();
  }

  constructor() { }
}
